var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 21.4,
    width: 9.9,
    height: 11.9,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinejoin: "round",
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.7,
    y1: 25.2,
    x2: 29.9,
    y2: 25.2,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.6,
    y1: 28.8,
    x2: 29.8,
    y2: 28.8,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 12.2,
    r: 6.2,
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3,33.2s3.1,0,5.5,0v-9.4c-1.3-1.7-3.1-3-5.5-2.9h.5c-7.1-.3-9.6,11.8-8.7,12.1s8.2.1,8.2.1h0Z",
    style: {
      fill: "none",
      stroke: "#0194d3",
      strokeMiterlimit: 10,
      strokeWidth: "1.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.1,
    cy: 28.8,
    r: 0.6,
    style: {
      fill: "#0194d3",
      stroke: "#0194d3",
      strokeLinejoin: "round"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfileIcon);
export default __webpack_public_path__ + "static/media/my-profile-icon.872f5b4aec346803aacb0a0b7a73fe96.svg";
export { ForwardRef as ReactComponent };